export const CompanyNotChangedFields = [
  'title',
  'opening_date',
  'closing_date',
  'contract_start_date',
  'company_category_id',
  'contract_end_date',
  'vat',
  'place_area',
  'commodity_category',
  'company_child_category_id',
  'prestige_level_id',
  'location_code',
  'food',


  'published',
  'profit_code',
  'commodity_category_id',
  'commodity_category_code',
  'prestige_level_nego_id',
];

// order = row order of "Contatti Aziendali" in the company form
export const EMPLOYEE_CONTACT_TYPES = [
  { title: 'Amministrazione', value: 'administrator' },
  { title: 'Retail Manager', value: 'retail_manager' },
  { title: 'Operations', value: 'operators' },
  { title: 'Marketing Manager', value: 'marketing_manager' },
  { title: 'Marketing - Altri contatti', value: 'marketing_other' },
  { title: 'Tecnico e Pilotage', value: 'technical_and_pilotage' },
  { title: 'Facilty', value: 'other' },
  { title: 'Responsabile Leasing', value: 'leasing_manager' },
];
